import React from 'react';
import { Users } from '../..';
import { USER_ROLES } from '../../../constants/constants';

export const TC_Manager_Users = (props) => (
  <Users title='Users' addNewBtnTitle='Add New User' managedRole='User' {...props} role={USER_ROLES.TC_EMPLOYEE} />
);
